var _path, _path2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBgFhd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 160,
    viewBox: "0 0 1920 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1920 0H0V60C0 115.228 44.7715 160 100 160H1920V0Z",
    fill: "#5964E0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_3747",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1920,
    height: 160
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1920 0H0V60C0 115.228 44.7715 160 100 160H1920V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_3747)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.0813802,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1571.01 -221.726C1593.29 -240.679 1626.28 -235.419 1636.36 -211.309L1795.8 170.285C1807.99 199.465 1778.49 233.105 1745.34 227.821L1233.3 146.193C1200.16 140.908 1191.45 101.178 1218.41 78.2396L1571.01 -221.726Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.0813802,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M337.404 -338.417C333.958 -364.769 367.259 -382.257 399.097 -370.816L883.548 -196.729C917.186 -184.642 923.884 -149.707 895.429 -134.764L463.404 92.1164C434.949 107.06 393.47 90.3909 389.829 62.5499L337.404 -338.417Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.0813802,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-97.2631 56.5825C-100.709 30.2308 -67.4075 12.7427 -35.5693 24.1837L448.881 198.271C482.519 210.358 489.217 245.293 460.762 260.236L28.7373 487.116C0.282346 502.06 -41.1971 485.391 -44.8372 457.55L-97.2631 56.5825Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgFhd);
export default __webpack_public_path__ + "static/media/bgFHD.b1c14d783557bee346e0d95e7cbd2972.svg";
export { ForwardRef as ReactComponent };